import { ChatTextItem } from '@akin-home/chat';
import { Text } from '@akin-home/text/native';
import { useResponsiveStyling } from '@akin-home/utils/native';
import { useWindowDimensions, View } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import styled from 'styled-components/native';

type Props = {
  chat_item: ChatTextItem;

  onPressOption(params: { value: string }): void;
};

export function ChatItemContent(props: Props) {
  const { chat_item } = props;

  const { width } = useWindowDimensions();
  const isSmall = width < 1000;

  const { mvs } = useResponsiveStyling();

  return (
    <Animated.View
      key={chat_item.data.text}
      style={{ gap: mvs(10) }}
      entering={FadeIn.duration(400)}
      exiting={FadeOut.duration(400)}
    >
      <MainText isSmall={isSmall}>{chat_item.data.text}</MainText>

      <View
        style={{
          gap: mvs(10, 3, { max: 10 }),
        }}
      >
        {chat_item.data.options?.map((option, idx) => (
          <OptionButton
            key={idx}
            onPress={() => props.onPressOption({ value: option.input.value })}
          >
            <OptionText isSmall={isSmall} key={option.label}>
              {option.label}
            </OptionText>
          </OptionButton>
        ))}
      </View>
    </Animated.View>
  );
}

const MainText = styled(Text)<{ isSmall: boolean }>`
  font-size: ${({ isSmall }) => (!isSmall ? '20px' : '17px')};
`;

const OptionText = styled(Text)<{ isSmall: boolean }>`
  font-size: ${({ isSmall }) => (!isSmall ? '17px' : '15px')};
`;

const OptionButton = styled.TouchableOpacity`
  padding: 8px 12px;
  border-radius: 8px;
  background-color: white;
  margin-bottom: 10px;

  border-width: 1px;
  border-color: #c5c5c5;
`;
